import React, { useEffect, useState , useRef} from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Header.css";
import { FaBarsStaggered } from "react-icons/fa6";
import { Button } from "react-bootstrap";
import Logo from "../../Image/MainLogo.png"
import { FaUserNinja ,FaSignOutAlt } from "react-icons/fa";

function Header({ toggleSidebar }) {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const authUser = localStorage.getItem("authUser");
  const authUserData = authUser ? JSON.parse(authUser) : null; // Added null check
  const adminId = authUserData?.admin?.id;

  useEffect(() => {
    if (!adminId) {
      //console.error("Admin ID is not available");
      return; // Exit early if adminId is not available
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}api/admin/loginAdminDetail`,
          { id: adminId }
        );
        setUser(response.data.admin);
      } catch (error) {
        //console.error("Error fetching user profile:", error);
      }
    };

    fetchUserDetails();
  }, [adminId]);

 
const handleSignOut = async () => {


  try {
    const token = localStorage.getItem("authUser"); 
  
    if (!token) {
      console.error("No token found");
      return;
    }
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}api/admin/logout`, 
      {}, 
      {
        headers: {
          Authorization: `Bearer ${token}`, 
        }
      }
    );

    const data = response.data;

    if (data.status === 1) {
    
      localStorage.removeItem("authUser");

      navigate("/login");
    } else {
      console.error("Logout failed:", data.errors?.message || "Unknown error");
    }
  } catch (err) {
    console.error("An error occurred during logout:", err.message);
    if (err.response && err.response.data && err.response.data.message === "jwt malformed") {
      console.error("Invalid token format. Redirecting to login...");
      localStorage.removeItem("authUser");
      navigate("/login");
    }
  }
};

  

  

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // Create a ref for the dropdown

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close the dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);


    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);





  return (
    <header id="header" className="header fixed-top d-flex align-items-center header-scrolled">

      <div className="SideLogDiv">
        <Link to="/"><img src={Logo} alt="Logo" /></Link>
        {/* <Button type="button"onClick={() => console.log("Logo clicked")}></Button> */}
      </div>
      <div className="RightHeader">

        <Button type="Submit" onClick={toggleSidebar}> <FaBarsStaggered className="toggle-sidebar-btn" /></Button>

        <div className="HeaderProfDiv">
          <ul className="NavUL">
            <li className="nav-item dropdown" ref={dropdownRef}>
              <Link className="d-flex align-items-center"onClick={toggleDropdown} >
                <img src={user?.profilePic} />
                {user?.name && <span>{user.name}</span>}
                <span className="d-none d-md-block dropdown-toggle"></span>
              </Link>
              <ul className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow profileUl ${ isOpen ? "show" : ""}`} >

                <li className="dropdown-header">
                  <h6>{user?.name || "Guest"}</h6>
                  <span>{user?.role || "SuperAdmin"}</span>
                </li>

                <li>
                  <hr className="dropdown-divider" />
                </li>

                <li className="dropdown-item d-flex align-items-center" >
                  <Link to="/Profile" >
                    <FaUserNinja />
                    <span>My Profile</span>
                  </Link>
                </li>

                <li>
                  <hr className="dropdown-divider" />
                </li>
                
                <li className="dropdown-item d-flex align-items-center" >
                  <Button onClick={handleSignOut}>
                    <FaSignOutAlt />
                    <span>Sign Out</span>
                  </Button>
                </li>

              </ul>
            </li>
          </ul>
        </div>

      </div>
      





    </header>
  );
}

export default Header;
